<template>
  <v-dialog v-model="loading" hide-overlay persistent width="300">
       <v-overlay :value="loading" opacity=0.9>
        <v-progress-circular indeterminate size="70" 
      :width="7"></v-progress-circular>
    </v-overlay>
   <!--  <v-card color="primary" dark>
      <v-card-text>
        en cours
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>  -->
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
   // console.log(this.loading);
  },
  computed: {
    ...mapState({
      loading: (state) => state.Loading.loading,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
